import { useContractItemsSourceSetWithFilter } from '@/app/state/ui/customerService/bottomGrid/contractItems/index.hooks';
import { useEventsSourceSetWithFilter } from '@/app/state/ui/customerService/bottomGrid/events/index.hooks';
import { useEventsByRfidSourceSetWithFilter } from '@/app/state/ui/customerService/bottomGrid/eventsByRfid/index.hooks';
import {
    STYLE_CONTRACTS,
    STYLE_EVENTS,
    STYLE_TASKS,
} from '../components/CscMap/utils/style';
import { useBottomGrid } from '@/app/state/ui/customerService/bottomGrid/index.hooks';
import { useTasksSourceSetWithFilter } from '@/app/state/ui/customerService/bottomGrid/tasks/index.hooks';

export const useBottomGridConfig = () => {
    const bottomGrid = useBottomGrid();

    const tasksSourceSet = useTasksSourceSetWithFilter();
    const contractsSourceSet = useContractItemsSourceSetWithFilter();
    const eventsSourceSet = useEventsSourceSetWithFilter();
    const eventsByRfidSourceSet = useEventsByRfidSourceSetWithFilter();

    const getSourceSet = () => {
        switch (bottomGrid) {
            case 'Tasks':
                return tasksSourceSet;
            case 'ContractItems':
                return contractsSourceSet;
            case 'Events':
                return eventsSourceSet;
            case 'EventsByRfid':
                return eventsByRfidSourceSet;
            default:
                return null;
        }
    };

    const getStyle = () => {
        switch (bottomGrid) {
            case 'Tasks':
                return STYLE_TASKS;
            case 'ContractItems':
                return STYLE_CONTRACTS;
            case 'Events':
            case 'EventsByRfid':
                return STYLE_EVENTS;
            default:
                return {};
        }
    };

    return { getSourceSet, getStyle };
};
